<div class="main-Content pagination">
  <div class="form-group row">
    <div class="col-sm-3">
      <h3>Beak Subscription</h3>
    </div>
    <div class="col-sm-3"></div>
    <div class="col-sm-3"> </div>
    <div class="col-sm-3">
      <select class="form-control" (change)="OnStatusChange()" #Status="ngModel" [(ngModel)]="userStatus" name="Status">
        <option value="All">All</option>
        <option value="Active">Active</option>
        <option value="InActive">InActive</option>
        <option value="Deleted">Deleted</option>
      </select>
    </div>
  </div>
  <table mat-table [dataSource]="dataSource" class="elevation" style="margin-top: -25px !important;">

    <!-- Position Column -->
    <ng-container matColumnDef="no">
      <th mat-header-cell *matHeaderCellDef>Sr. No</th>
      <td style="margin-top: 50px;height: 50px;padding-left: 35px;" mat-cell *matCellDef="let element ; let i = index;">
        {{paginator.pageSize * paginator.pageIndex + i + 1}}</td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name" style="width: 100px !important;">
      <th mat-header-cell *matHeaderCellDef> Name </th>
      <td mat-cell *matCellDef="let element">{{element.fullName}}</td>
      <router-outlet></router-outlet>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef>Company Name </th>
      <td mat-cell *matCellDef="let element"><a routerLink="/beak-customer/{{element.companyName}}">
          {{element.companyName}} </a></td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="mobile" style="width: 100px !important;">
      <th mat-header-cell *matHeaderCellDef>Mobile </th>
      <td mat-cell *matCellDef="let element"> {{element.phoneNumber}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="email" style="width: 30% !important;">
      <th mat-header-cell *matHeaderCellDef>Email </th>
      <td mat-cell *matCellDef="let element"> {{element.email}} </td>
    </ng-container>

    <ng-container matColumnDef="registereddate">
      <th mat-header-cell *matHeaderCellDef>Register Date </th>
      <td mat-cell *matCellDef="let element"> {{element.createdDateString}} </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status </th>
      <td mat-cell *matCellDef="let element" style="padding-left: 25px;">
        <span *ngIf="element.statusString == 'Active'" #tooltip="matTooltip" matTooltip="Active"
          class="green-bg FontWeight500">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
            <g id="outline-calendar_today-24px" transform="translate(-2 -2)">
              <path id="Path_6947" data-name="Path 6947"
                d="M6.667,0h6.667A6.667,6.667,0,0,1,20,6.667v6.667A6.667,6.667,0,0,1,13.333,20H6.667A6.667,6.667,0,0,1,0,13.333V6.667A6.667,6.667,0,0,1,6.667,0Z"
                transform="translate(2 2)" fill="#2fda50" />
            </g>
          </svg>
        </span>
        <span *ngIf="element.statusString == 'InActive'" #tooltip="matTooltip" matTooltip="InActive"
          class="grey-bg FontWeight500">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
            <g id="outline-calendar_today-24px" transform="translate(-2 -2)">
              <path id="Path_6947" data-name="Path 6947"
                d="M6.667,0h6.667A6.667,6.667,0,0,1,20,6.667v6.667A6.667,6.667,0,0,1,13.333,20H6.667A6.667,6.667,0,0,1,0,13.333V6.667A6.667,6.667,0,0,1,6.667,0Z"
                transform="translate(2 2)" fill="#a9aaa9" />
            </g>
          </svg>
        </span>
        <span *ngIf="element.statusString == 'Deleted'" #tooltip="matTooltip" matTooltip="Deleted"
          class="red-bg FontWeight500">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
            <g id="outline-calendar_today-24px" transform="translate(-2 -2)">
              <path id="Path_6947" data-name="Path 6947"
                d="M6.667,0h6.667A6.667,6.667,0,0,1,20,6.667v6.667A6.667,6.667,0,0,1,13.333,20H6.667A6.667,6.667,0,0,1,0,13.333V6.667A6.667,6.667,0,0,1,6.667,0Z"
                transform="translate(2 2)" fill="#ff4b3d" />
            </g>
          </svg>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="tool">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element" style="margin-top: 5px;">
        <span class="cursor" (click)="OnEditClick(element.companyName)" #tooltip="matTooltip"
          matTooltip="Update Customer" style="margin-top: 10px;margin-bottom: 10px;" href="javascript:void(0);"><i
            class="fa fa-pencil font18" aria-hidden="true"></i> </span> &nbsp;&nbsp;
        <span class="cursor" *ngIf="element.statusString == 'Active'" (click)="DeActivateCustomer(element.id)"
          #tooltip="matTooltip" matTooltip="Deactivate Customer" href="javascript:void(0);"> <i
            class="fa fa-times-circle font18"></i></span> &nbsp;&nbsp;
        <span class="cursor" *ngIf="element.statusString == 'Active' || element.statusString == 'InActive'"
          (click)="DeleteCustomer(element.id)" #tooltip="matTooltip" matTooltip="Delete Customer"
          href="javascript:void(0);"><i class="fa fa-trash font18" aria-hidden="true"></i> </span>
      </td>

    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


  </table>
  <table>
    <tr *ngIf="loading" style="height: 300px;background-color: #fff;">
      <td>
        <mat-progress-spinner strokeWidth="3" [color]="color" [mode]="mode" [value]="value" [diameter]="diameter"
          style="margin: auto;">
        </mat-progress-spinner>
      </td>
    </tr>
    <tr *ngIf="total == 0">
      <td colspan="10" style="background-color: rgb(249, 216, 216); color: Red; text-align: center; height: 50px;">No
        Customers</td>
    </tr>
  </table>
  <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
  </mat-paginator>

</div>